import React from 'react'
import chmln from '@chamaeleonidae/chmln'
import { getUserSession } from 'helpers/getUserSession.helper'
import {
  canActiveChmln,
  canIdenetifyChmln,
  currentUserFormatted,
} from 'helpers/chameleon.helper'
import { useAccess } from 'contexts/AccessContext'

export function useChameleon() {
  const { can, isAdmin, isScopedUser, isSuperadmin, loading, access } =
    useAccess()

  React.useEffect(() => {
    if (loading || !access) return
    const currentUser: any = getUserSession()
    try {
      if (canActiveChmln() && canIdenetifyChmln(currentUser)) {
        chmln.identify(currentUser.token, {
          ...currentUserFormatted(currentUser),
          LMS: {
            admin: isAdmin(),
            superadmin: isSuperadmin(),
            // ABAC (nombres nuevos; no reintroducir moderator/supervisor legacy)
            scopedUser: isScopedUser(),
            manageCourseRequests: can('manageCourseRequests'),
            permissions: access.flags,
          },
        })
      }
    } catch (error) {
      console.error('Chameleon init failed', error)
    }
  }, [access, can, isAdmin, isScopedUser, isSuperadmin, loading])
}
